export const el=(id)=>document.getElementById(id);
export const qs=(sel,root=document)=>root.querySelector(sel);
export const qsa=(sel,root=document)=>Array.from(root.querySelectorAll(sel));
